import React, { useEffect, useRef, useState } from 'react';
import { Col, Form, Row } from 'antd';
import axios from "axios"
import './additional-details.css';
import { useQuizFormContext } from '../../../../hooks/quiz-form-context';
import SelectionInput from '../../../../components/SelectionInput';
import BooleanInput from '../../../../components/BooleanInput';
import CheckboxInput from '../../../../components/CheckboxInput';
import QuizFormButtons from '../../../../components/quiz-form-buttons/quiz-form-buttons'
import RegisterWarnContainer from '../../../../components/register-warn-container/register-warn-container';
import MultipleTextBox from '../../../../components/MultipleTextBox/MultipleTextBox';
import MultipleTextBoxWithDescription from '../../../../components/MultipleTextBoxWithDescription/MultipleTextBoxWithDescription';
import TextHeading from '../../../../components/TextHeading';
import InputsAccordian from '../../../../components/AccordianInput/AccordianInput';
import TextInput from '../../../../components/TextInput';
import Multiselect from '../../../../components/Multiselect';
import { useNavigate, useParams } from 'react-router-dom';
import CommitteeTextInput from '../../../../components/CommitteeTextInput';
import CustomEditor from '../../../../components/Jodit';


const AdditionalDetails = ({ inputFields, nextPage, backPage, pageType }) => {

  const [stepOneData, setStepOneData] = useState({ formValues: [] });
  let stepTwoAllQuestionsId = []
  const navigate = useNavigate()

  const {
    formValues,
    setFormValues,
    allFormErrorsList,
    setAllFormErrorsList,
    contentFullErrorMsg,
    setContentFulErrorMsg,
    getInputValues,
    isLoggin,
    setComitteeSectionToShow,
    setIsFormValuesSaved
  } = useQuizFormContext();
  const { handbookId } = useParams()

  const tempContentFullErrorMsgsRef = useRef({});

  function getFirstStepData() {
    const data = JSON.parse(localStorage.getItem('quiz-step1-page1'));
    setStepOneData(data);
  }

  useEffect(() => {
    getFirstStepData();
  }, []);

  //LOGIC TO HIDE SHOW COMPONENT AS PER REQUIREMENT[ conditon true means show COMPONENT else dont show]
  function checkInputRequirements(requirements) {
    for (const field of requirements?.questionRequirements || []) {
      if (field?.fields) {
        let formFieldObj = {};
        switch (field?.fields?.question?.fields?.id) {
          // cases omitted for brevity
          case '5': {
            //isDesignated Substances
            formFieldObj = getInputValues('5', stepOneData.formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }

          case '8': {
            //BusinessSector
            formFieldObj = getInputValues('8', stepOneData.formValues);
            return formFieldObj?.value?.some(
              (sector) => sector?.value === String(field.fields.answerTest?.selected),
            );
          }
          case '9': {
            //Service
            formFieldObj = getInputValues('9', stepOneData.formValues);
            return formFieldObj?.value?.some(
              (sector) => sector?.value === String(field.fields.answerTest?.selected),
            );
          }
          case '10': {
            //Manufacturing
            formFieldObj = getInputValues('10', stepOneData.formValues);
            return formFieldObj?.value?.some(
              (sector) => sector?.value === String(field.fields.answerTest?.selected),
            );
          }
          case '11': {
            //Agriculture
            formFieldObj = getInputValues('11', stepOneData.formValues);
            return formFieldObj?.value?.some(
              (sector) => sector?.value === String(field.fields.answerTest?.selected),
            );
          }
          case '5': {
            //DesignatedSubstances
            formFieldObj = getInputValues('5', stepOneData.formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value?.value) === String(field.fields.answerTest?.selected)
            );
          }

          case '12': {
            //isNaloxone
            formFieldObj = getInputValues('12', stepOneData.formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }

          case '14': {
            //IsReplaceCompanyPolicyStatement
            formFieldObj = getInputValues('14', formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }

          case '17': {
            //IsAddDutiesAndResponsibilities
            formFieldObj = getInputValues('17', formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }

          case '22': {
            //IsAccountabilitiesDisciplineContent
            formFieldObj = getInputValues('22', formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }

          case '37': {
            //isIncludeEmergencyInformation
            formFieldObj = getInputValues('37', formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }

          case '41': {
            //isEyeWashStation
            formFieldObj = getInputValues('41', formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }

          case '42': {
            //isChemicalShower
            formFieldObj = getInputValues('42', formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }

          case '45': {
            //IsReplaceHazardReportingContent
            formFieldObj = getInputValues('45', formValues);
            return (
              formFieldObj.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }

          case '48': {
            //IsAddInspectionRequirements
            formFieldObj = getInputValues('48', formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }

          case '66': {
            //IsReplaceViolenceHarassmentPP
            formFieldObj = getInputValues('66', formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }

          case '70': {
            //IsAddPPEInHandbook
            formFieldObj = getInputValues('70', formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }

          case '74': {
            //IsAddPPEInHandbook
            formFieldObj = getInputValues('74', formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }
          case '92': {
            //All hazards
            formFieldObj = getInputValues('92', formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }
          case '96': {
            //IsReplaceCompanyPolicyStatement
            formFieldObj = getInputValues('96', formValues);
            return (
              formFieldObj?.value &&
              String(formFieldObj.value) === String(field.fields.answerTest?.selected)
            );
          }
          default: {
            return true;
          }

        }
      }
    }
    return false;
  }

  function findIndexFromFormValue(key, formValues) {
    const indexToRemove = formValues?.findIndex((obj) => key in obj);
    return indexToRemove;
  }

  //To RESET ALL HIDDEN INPUTS VALUES{Doing this beacause 1st user YES selected and after if User selected No then have to Delete its sub dependent hidden Input value }
  function resetAllHiddenInputValue() {
    // Logic omitted for brevity
    let conditionalFieldsIds = [
      '3',
      '14',
      '17',
      '22',
      '37',
      '41',
      '42',
      '45',
      '48',
      '66',
      '70',
      '74',
      '96'
    ];

    const fieldConfig = [
      { fieldId: '3', fieldToCheck: '4' },
      { fieldId: '14', fieldToCheck: '15' },
      { fieldId: '22', fieldToCheck: '23' },
      { fieldId: '37', fieldToCheck: '38' },
      { fieldId: '41', fieldToCheck: '72' },
      { fieldId: '42', fieldToCheck: '73' },
      { fieldId: '45', fieldToCheck: '46' },
      { fieldId: '66', fieldToCheck: '67' },
      { fieldId: '70', fieldToCheck: '71' },
      { fieldId: '48', fieldToCheck: '49' },
      { fieldId: '74', fieldToCheck: '75' },
      { fieldId: '96', fieldToCheck: '97' },
      // Add more configurations as needed
    ];

    conditionalFieldsIds.forEach((fieldId) => {
      let fieldValue = getInputValues(fieldId, formValues);

      const config = fieldConfig.find((config) => config.fieldId === fieldId);

      if (config && fieldValue && fieldValue?.value !== true) {
        let indexToRemove = findIndexFromFormValue(config.fieldToCheck, formValues);
        if (indexToRemove !== -1) {
          formValues?.splice(indexToRemove, 1); // remove the field from FormValues
        }
      }

      // if (fieldId === '17') {
      //   // isAdd Content duties and responsibilities
      //   if (fieldValue && fieldValue?.value !== true) {
      //     let romoveFieldsIds = ['18', '19', '20'];
      //     romoveFieldsIds?.forEach((id) => {
      //       let indexToRemove = findIndexFromFormValue(id, formValues);
      //       if (indexToRemove !== -1) {
      //         formValues?.splice(indexToRemove, 1);
      //       }
      //     });
      //   }
      // }
    });
  }

  //TO DISPLAY Input FIELDS AS PER questionType
  function renderInputFieldsHandler(inputFields, index) {
    const { fields: inputValues } = inputFields;
    //Storing all inputs error messages
    if (
      inputFields?.fields?.error &&
      inputFields?.fields?.id &&
      !inputFields?.fields?.questionRequirements
    ) {
      tempContentFullErrorMsgsRef.current = {
        ...tempContentFullErrorMsgsRef.current,
        [inputValues.id]: inputFields.fields?.error,
      };
    }
    stepTwoAllQuestionsId = [...stepTwoAllQuestionsId, inputValues?.id]
    //Checking Requirements to Show Hide Questions
    if (inputValues?.questionRequirements || inputValues?.anwerRequirements) {
      const isValid = checkInputRequirements(inputValues);
      if (isValid === true && inputFields.fields?.error) {
        tempContentFullErrorMsgsRef.current = {
          ...tempContentFullErrorMsgsRef.current,
          [inputValues.id]: inputFields.fields?.error,
        };
      }
      if (isValid === undefined || !isValid) {
        return;
      }
    }

    //TO SHOW COMMITTEE QUESTION
    if (
      inputFields.sys?.contentType?.sys?.id == 'accordion' &&
      inputValues?.type == 'Committee'
    ) {
      if (stepOneData?.outcome?.outcome !== inputFields.sys?.id) {
        return false;
      } else {
        setComitteeSectionToShow(inputFields?.fields?.accordionQuestions[0]?.fields?.id)
      }
    }

    switch (inputValues?.questionType || inputFields.sys?.contentType?.sys?.id) {
      case 'String': {
        return (
          <TextInput
            title={inputValues.title}
            name={inputValues.id}
            description={inputValues?.description}
            Error={inputValues?.error}
            size="large"
            allInputOnchageHandler={allInputOnchageHandler}
            anwerRequirements={inputValues?.anwerRequirements}
            indexKey={index}
            questionTooltip={inputValues?.questionTooltip}
          />
        );
      }
      case 'Committee String': {
        return (
          <CommitteeTextInput
            title={inputValues.title}
            name={inputValues.id}
            description={inputValues?.description}
            Error={inputValues?.error}
            size="large"
            allInputOnchageHandler={allInputOnchageHandler}
            anwerRequirements={inputValues?.anwerRequirements}
            indexKey={index}
            questionTooltip={inputValues?.questionTooltip}
          />
        );
      }
      case 'Textarea': {
        return (
          <CustomEditor
            title={inputValues.title}
            name={inputValues.id}
            description={inputValues?.description}
            Error={inputValues?.error}
            size="large"
            allInputOnchageHandler={allInputOnchageHandler}
            anwerRequirements={inputValues?.anwerRequirements}
            indexKey={index}
            questionTooltip={inputValues?.questionTooltip}
          />
        );
      }

      case 'Multiple Text Box': {
        return (
          <MultipleTextBox
            title={inputValues.title}
            name={inputValues.id}
            description={inputValues?.description}
            Error={inputValues?.error}
            size="large"
            allInputOnchageHandler={allInputOnchageHandler}
            indexKey={index}
            questionTooltip={inputValues?.questionTooltip}
          />
        );
      }

      case 'Multiple Text Box with Description': {
        return (
          <MultipleTextBoxWithDescription
            title={inputValues.title}
            name={inputValues.id}
            description={inputValues?.description}
            Error={inputValues?.error}
            size="large"
            allInputOnchageHandler={allInputOnchageHandler}
            indexKey={index}
            questionTooltip={inputValues?.questionTooltip}
          />
        );
      }

      case 'Boolean': {
        return (
          <BooleanInput
            title={inputValues.title}
            name={inputValues.id}
            description={inputValues.description}
            Error={inputValues?.error}
            questionValueOptions={inputValues.questionValueOptions}
            allInputOnchageHandler={allInputOnchageHandler}
            indexKey={index}
            questionTooltip={inputValues?.questionTooltip}
          />
        );
      }
      case 'Selection': {
        return (
          <SelectionInput
            title={inputValues.title}
            name={inputValues.id}
            description={inputValues.description}
            Error={inputValues?.error}
            questionValueOptions={inputValues.questionValueOptions}
            allInputOnchageHandler={allInputOnchageHandler}
            indexKey={index}
            questionTooltip={inputValues?.questionTooltip}
          />
        );
      }
      case 'Checkbox': {
        return (
          <CheckboxInput
            title={inputValues.title}
            description={inputValues.description}
            name={inputValues.id}
            Error={inputValues?.error}
            // values={inputValues.questionValues}
            questionValueOptions={inputValues?.questionValueOptions}
            allInputOnchageHandler={allInputOnchageHandler}
            indexKey={index}
            questionTooltip={inputValues?.questionTooltip}
          />
        );
      }

      case 'accordion': {
        return (
          <InputsAccordian
            name={inputValues?.id}
            title={inputValues?.title}
            description={inputValues?.description}
            indexKey={index}
            accordionQuestions={inputValues?.accordionQuestions}
            renderInputFieldsHandler={renderInputFieldsHandler}
            questionTooltip={inputValues?.questionTooltip}
          ></InputsAccordian>
        );
      }

      case 'Heading': {
        return (
          <TextHeading
            label={inputValues.title}
            description={inputValues.description}
            name={inputValues.id}
            indexKey={index}
          ></TextHeading>
        );
      }
      case 'Multiselect': {
        return (
          <Multiselect
            title={inputValues.title}
            name={inputValues.id}
            allInputOnchageHandler={allInputOnchageHandler}
            indexKey={index}
            questionValueOptions={inputValues?.questionValueOptions} />
        );
      }
      default: {
        return <></>;
      }
    }
  }

  //ALL INPUT ONCHANGE HANDLER

  const allInputOnchageHandler = (
    indexKey,
    title,
    name,
    val,
    sysid,
  ) => {
    setIsFormValuesSaved(false)
    if (Object.keys(allFormErrorsList)?.length > 0) {
      if ((val !== '' || val?.length > 0) && allFormErrorsList[name]) {
        const errors = allFormErrorsList;
        delete errors[name];
        setAllFormErrorsList(errors);
      }
    }
    setFormValues((prev) => {
      const updatedValues = [...prev];
      const existingIndex = updatedValues.findIndex((item) => item?.hasOwnProperty(name));

      if (existingIndex === -1) {
        // If the key doesn't exist, add a new entry
        updatedValues.push({
          [`${name}`]: {
            id: sysid,
            questionName: title,
            value: val,
          },
        });
      } else {
        // If the key already exists, replace the existing entry
        updatedValues[existingIndex] = {
          [`${name}`]: {
            id: sysid || prev[existingIndex][name]?.id,
            questionName: title,
            value: val,
          },
        };
      }

      return updatedValues;
    });
  };

  function registerToSave() {
    localStorage.setItem("registerToSaveSkipToPage1", true);
    let selectedHazardValue = modifyValForWorkPlaceHazards();
    localStorage.setItem('selected-workplace-hazard-backup', JSON.stringify(selectedHazardValue));
    localStorage.setItem('quiz-step1-page1-backup', (localStorage.getItem('quiz-step1-page1')));
    localStorage.setItem('quiz-step2-page1-backup', JSON.stringify(formValues));
  }

  //SAVE FORMDATA TO LOCAL STORAGE
  const handleNextPageAction = () => {
    const isValid = checkQuizFormValidation();
    if (!isValid) {
      return false;
    }
    let selectedHazardValue = modifyValForWorkPlaceHazards();
    resetAllHiddenInputValue();

    const isHazardsFullListVisible = getInputValues('92', formValues)?.value
    let hazardsFromFullList
    if (!isHazardsFullListVisible) {
      hazardsFromFullList = []
    }
    else {
      hazardsFromFullList = getInputValues('93', formValues)?.value || []
    }
    localStorage.setItem('selected-workplace-hazard', JSON.stringify([...selectedHazardValue, ...hazardsFromFullList]));
    localStorage.setItem('quiz-step2-page1', JSON.stringify(formValues));
    return true
  }
  async function saveFormData() {
    let handBookSave;
    const isValid = checkQuizFormValidation();
    if (!isValid) {
      return false;
    }
    if (JSON.parse(localStorage.getItem("loginToken"))) {
      localStorage.setItem('quiz-step2-page1', JSON.stringify(formValues));
      handBookSave = await saveFormValuesToDB(formValues);
    }
    if (!handbookId) {
      navigate(`/safety-orientation-handbook/quiz/${handBookSave?.jsonBody?.handbookResult?.id}`)
    }
    return handBookSave ? true : false;
  }

  //Modifing WORKPLACE HAZARDS DATA FOR QUIZ STEP3 PAGE
  function modifyValForWorkPlaceHazards() {
    let workPlaceHazardsQueIds = [
      '51',
      '52',
      '53',
      '54',
      '55',
      '56',
      '57',
      '58',
      '59',
      '60',
      '61',
      '62',
      '63',
      '64',
      '76'
    ];
    let selectedHazardVals = [];

    workPlaceHazardsQueIds?.forEach((id) => {
      let formFieldObj = getInputValues(id, formValues);
      if (Object.keys(formFieldObj)?.length > 0) {
        selectedHazardVals = [...selectedHazardVals, ...formFieldObj?.value];
      }
    });
    return selectedHazardVals;
  }

  //RESET FORMDATA
  function resetFormData() {
    localStorage.setItem("reset", true)
    setFormValues([]);
    localStorage.removeItem('quiz-step1-page1');
    localStorage.removeItem('quiz-step2-page1');
    window.location.reload()
  }

  //GO TO BACK PAGE
  function backPageHandler() {
    setAllFormErrorsList({});
    backPage();
  }

  // FORM VALIDATION LOGIC
  function checkQuizFormValidation() {
    let errors = {};
    const stepTwoContentfulErrors = {};
    stepTwoAllQuestionsId?.forEach(key => {
      // Check if the key exists in contentFullErrorMsg
      if (contentFullErrorMsg.hasOwnProperty(key)) {
        stepTwoContentfulErrors[key] = contentFullErrorMsg[key];
      }
    });
    for (let key in stepTwoContentfulErrors) {
      const fieldValue = getInputValues(key, formValues);
      if (Object.keys(fieldValue)?.length <= 0 || fieldValue?.value === '') {
        errors[key] = stepTwoContentfulErrors[key] || `${key} is required`;
      }
      if (Object.keys(fieldValue)?.length >= 0 && fieldValue?.value && Array.isArray(fieldValue?.value)) {
        if (fieldValue?.value?.length === 0) {
          errors[key] = stepTwoContentfulErrors[key] || `${key} is required`;
        }
      }
    }
    if (Object.keys(errors)?.length > 0) {
      setAllFormErrorsList(errors);
      return false;
    } else {
      return true;
    }
  }

  // Function to check deep equality of two objects
  const isEqualObject = (obj1, obj2) => {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      const val1 = obj1[key];
      const val2 = obj2[key];

      if (typeof val1 === 'object' && typeof val2 === 'object') {
        if (!isEqualObject(val1, val2)) {
          return false;
        }
      } else if (val1 !== val2) {
        return false;
      }
    }

    return true;
  };

  const renderHeading = () => {
    return (<div className="heading-container">
      <div className='basic-details-text'>Additional Details</div>
      <h1>Workplace Additional Details</h1>
      <span>*Required field</span>
    </div>)
  }
  const renderFormErrors = () => {
    return Object.keys(allFormErrorsList).length > 0 && (
      <div className="error-list-container">
        <div className="warn-message-container">
          <img className="worn-icon" src="./images/error-icon.png" alt="warn-icon" />
          <span style={{ color: '#FF564A' }}>Errors were detected in the following fields:</span>
        </div>
        <ul className="error-list">
          {Object.keys(allFormErrorsList).map((errorKey) => (
            <li className="error-item" key={errorKey}>
              {allFormErrorsList[errorKey]}
            </li>
          ))}
        </ul>
      </div>)
  }
  //ON SUBMIT API CALL 
  async function saveFormValuesToDB(formValues) {
    try {
      let endpoint = `${process.env.REACT_APP_BASE_URL}/handbook/`
      if (handbookId) {
        endpoint = `${process.env.REACT_APP_BASE_URL}/handbook/${handbookId}`;
      }
      const token = JSON.parse(localStorage.getItem('loginToken'));
      // Convert the formValues array to a JSON string
      const requestBody = handbookId
        ? JSON.stringify({
          _id: handbookId,
          basicDetails: stepOneData,
          additionalDetails: formValues,
        })
        : JSON.stringify({
          basicDetails: stepOneData,
          additionalDetails: formValues,
        });

      // Make the HTTP POST request using Axios
      const response = await axios({
        method: handbookId ? 'PUT' : 'POST',
        url: endpoint,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: requestBody,
      });

      return response?.data;
    } catch (error) {
      console.error('Error:', error);
    }
  }


  //LOGIC TO SHOW ERROR ON UI
  useEffect(() => {
    const tempContentFullErrorMsgs = tempContentFullErrorMsgsRef.current;
    // Only update the state if the value has changed
    if (!isEqualObject(tempContentFullErrorMsgs, contentFullErrorMsg)) {
      setContentFulErrorMsg(tempContentFullErrorMsgs);
    }
  }, [tempContentFullErrorMsgsRef?.current, contentFullErrorMsg]);

  return (
    <>
      <div className="quiz-form-main-container quiz-step2-page1">
        {pageType === 'AdditionalDetails' && (
          <div>
            {renderHeading()}
            {
              !isLoggin && <RegisterWarnContainer registerToSaveWarn={() => registerToSave()} />
            }
            {renderFormErrors()}
            <div className="form-wrapper-container">
              <Form
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                layout="vertical"
                className="form-container"
              >
                <div className="section-container">
                  <Row className="field-container">
                    {inputFields.fields?.questionType?.map((field, index) => (
                      <Col key={field.sys.id} span={24}>
                        <div className={field?.fields?.questionRequirements ? "requirement-border" : ""}>
                          {renderInputFieldsHandler(
                            field,
                            stepOneData.formValues?.length + index + 1,
                          )}
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Form>
              <QuizFormButtons
                pageType="AdditionalDetails"
                nextPageClick={() => nextPage()}
                backPageClick={backPageHandler}
                registerToSave={() => registerToSave()}
                saveFormData={saveFormData}
                resetFormData={resetFormData}
                isLoggin={isLoggin}
                handleNextPageAction={handleNextPageAction}
              />
            </div>
          </div>
        )}
      </div>

    </>
  );
};

export default AdditionalDetails;
